import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './SpringCleaning.module.scss';
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";

const SpringCleaning = () => {
  const dispatch = useDispatch();
  const {countRooms, countBathrooms} = useSelector(state => state.stepperInfo);

  const handleChangeCountRooms = (e) => {
    // clear error if it exists
    const roomsCountLabel = document.getElementById("rooms_count");

    if (roomsCountLabel) {
      const inputElement = roomsCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = roomsCountLabel.querySelector("span");
      if (errorMessageSpan) {
        roomsCountLabel?.removeChild(errorMessageSpan);
      }
    }
    const bathroomCountLabel = document.getElementById("bathroom_count");

    if (bathroomCountLabel) {
      const inputElement = bathroomCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = bathroomCountLabel.querySelector("span");
      if (errorMessageSpan) {
        bathroomCountLabel?.removeChild(errorMessageSpan);
      }
    }

    const count = e.target.value;

    const regex = /^\d+$/;
    if (regex.test(count)) {
      dispatch(stepperInfoActions.setCountRooms(count));
    } else {
      dispatch(stepperInfoActions.setCountRooms(""));
    }
  }

  const handleChangeCountBathrooms = (e) => {
    // clear error if it exists
    const bathroomCountLabel = document.getElementById("bathroom_count");

    if (bathroomCountLabel) {
      const inputElement = bathroomCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = bathroomCountLabel.querySelector("span");
      if (errorMessageSpan) {
        bathroomCountLabel?.removeChild(errorMessageSpan);
      }
    }
    const roomsCountLabel = document.getElementById("rooms_count");

    if (roomsCountLabel) {
      const inputElement = roomsCountLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = roomsCountLabel.querySelector("span");
      if (errorMessageSpan) {
        roomsCountLabel?.removeChild(errorMessageSpan);
      }
    }

    const count = e.target.value;

    const regex = /^\d+$/;
    if (regex.test(count)) {
      dispatch(stepperInfoActions.setCountBathrooms(count));
    } else {
      dispatch(stepperInfoActions.setCountBathrooms(""));
    }
  }

  return (
    <div className={styles.springCleaning}>
      {/*<p>Генеральне прибирання <sup>*</sup></p>*/}

      <div className={styles.springCleaning_inputsContainer}>
        <div className={styles.springCleaning_inputsContainer_block}>
          <p>Кількість кімнат</p>

          <form action="#">
            <label id={"rooms_count"}>
              <input
                value={countRooms}
                onChange={handleChangeCountRooms}
                className={styles.input}
                type="number"
                placeholder={'Напишіть кількість'}
                min={1}
              />
            </label>
          </form>
        </div>

        <div className={styles.springCleaning_inputsContainer_block}>
          <p>Кількість санвузлів</p>

          <form action="#">
            <label id={"bathroom_count"}>
              <input
                value={countBathrooms}
                onChange={handleChangeCountBathrooms}
                className={styles.input}
                type="number"
                placeholder={'Напишіть кількість'}
                min={1}
              />
            </label>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SpringCleaning;
